import React from "react";
import ErrorsLayout from "..";

const Page404 = () => {
  return (
    <ErrorsLayout
      title="Página não encontrada"
      description="A página que você está procurando não foi encontrada ou não existe."
      hideRefresh={true}
    />
  );
};

export default Page404;